<template>
  <VeeForm
    :key="formKey"
    v-slot="{ validate }"
    :initial-values="initialValues"
    as="div"
    class="calico-document-upload-inline"
  >
    <div class="document">
      <div class="file-content">
        <CalicoForm
          v-slot="{ error }"
          name="year"
          label="Year"
          rules="required"
        >
          <CalicoDropdown
            :model-value="newDocument.year"
            :error="error"
            @update:modelValue="value => newDocument.year = value"
          >
            <option value="">
              Select year
            </option>
            <option
              v-for="item in years"
              :key="item"
              :value="item"
            >
              {{ item }}
            </option>
          </CalicoDropdown>
        </CalicoForm>

        <CalicoForm label="Document">
          <label class="label--xsmall">
            {{ newDocument.type }}
          </label>
        </CalicoForm>

        <CalicoForm label="File">
          <CalicoFileCard
            :name="newDocument.name"
            :type="newDocument.type"
            :size="fileSize"
          />
        </CalicoForm>
      </div>

      <CalicoForm
        v-slot="{ field, error }"
        name="description"
        label="Description"
        message="Max. 90 characters"
        :rules="descriptionRule"
      >
        <CalicoField
          v-model="newDocument.description"
          v-bind="field"
          :error="error"
          placeholder="ex. Record of sales"
        />
      </CalicoForm>
    </div>

    <div
      class="buttons"
      style="width: fit-content"
    >
      <button
        type="button"
        class="button-primary button-primary--small"
        @click="onSave(validate)"
      >
        <i class="bi bi-check-lg" />
        Save
      </button>
      <button
        type="button"
        class="button-secondary button-secondary--small"
        @click="$emit('cancel', newDocument)"
      >
        <i class="bi bi-x-lg" />
        Cancel
      </button>
    </div>
  </VeeForm>
</template>

<script>
import { Form as VeeForm } from 'vee-validate'
import CalicoField from '@/components/calico/field/index.vue'
import CalicoDropdown from '@/components/calico/dropdown/index.vue'
import CalicoFileCard from '@/components/calico/fileCard/index.vue'
import CalicoForm from '@/components/pattern/form/index.vue'

const emptyDocument = () => ({
  name: '',
  type: '',
  size: 0,
  year: '',
  description: ''
})

export default {
  name: 'CalicoDocumentUploadInline',
  components: {
    VeeForm,
    CalicoField,
    CalicoDropdown,
    CalicoFileCard,
    CalicoForm
  },
  props: {
    document: {
      type: Object,
      default: () => emptyDocument()
    }
  },
  emits: ['save', 'cancel'],
  data () {
    const doc = { ...emptyDocument(), ...this.document }

    return {
      formKey: 0,
      newDocument: doc
    }
  },
  computed: {
    initialValues () {
      return {
        year: this.newDocument.year || '',
        description: this.newDocument.description || ''
      }
    },
    years () {
      const currentYear = new Date().getFullYear()
      const startYear = 2000
      const years = []

      for (let year = currentYear; year >= startYear; year--) {
        years.push(String(year))
      }

      return years
    },
    fileSize () {
      return Math.floor(this.newDocument.size / 1024) + 'kb'
    },
    descriptionRule () {
      return this.newDocument.type === 'other' ? 'required' : ''
    }
  },
  watch: {
    document: {
      deep: true,
      handler (value) {
        this.newDocument = { ...emptyDocument(), ...value }
        this.formKey += 1
      }
    }
  },
  methods: {
    async onSave (validate) {
      const result = await validate()

      if (!result.valid) return

      this.$emit('save', { ...this.newDocument })
    }
  }
}
</script>

<style lang="scss">
.calico-document-upload-inline {
  @include inset-space($radius-medium);
  @include stack-space($space-medium);
  border: 1px solid $color-neutral;
  border-radius: $radius-medium;

  .document {
    @include stack-space($space-medium);

    .file-content {
      @include inline-space($space-xlarge);
      width: fit-content;
    }
  }

  .buttons {
    @include inline-space($space-small);
  }

  .calico-form {
    .label--medium {
      font-family: $font-label;
      font-weight: $font-weight-regular;
      font-size: $font-size-xsmall;
      line-height: $line-height-small;
    }
  }
}
</style>